<template>
  <div>
    <h2 class="black--text">Link Rekaman</h2>
    <v-list>
      <v-list-item class="px-0" v-for="(rekaman, id) in rekamans" :key="id">
        <v-list-item-content class="py-2">
          <span class="px-0 body-2 grey--text" style="height: 24px;">
            Rekaman Video Conference <span v-if="rekamans.length > 1">{{ id + 1 }}</span>
          </span>
          <div :class="['black--text', 'grey lighten-3 pa-3']" style="border-radius: 5px">
            <a :href="rekaman.url_meeting" target="_blank"> {{ rekaman.url_meeting }} </a>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'LinkRekaman',
  props: {
    rekamans: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped></style>
